import React, { useReducer, useContext } from "react";

const initialLiftDashboardState = {
  response: {
    status: -1,
    statusText: "",
    liftStatus: -1,
    liftAmount: 0,
    totalBalance: 0,
    totalBalanceWithFee: 0,
    biWeeklyPayment: 0,
    numberOfPayments: 0,
    boosterCode: "",
    timeToEnrollBooster: 0,
    firstName: "",
    lastName: "",
    communityContribution: 0,
    principalRepayment: 0,
    boosters: [],
    numberPaymentTillLiftIncrease: 0,
    nextPaymentDueDate: 0,
    numberPaymentsToGo: 0,
    numberPaymentsMade: 0,
    liftId: "",
    fractionPayedOff: 0,
    maxBoosterCountReached: false,
    paymentsByLiftOwner: 0,
    bannerMessage: "",
    boosterReleaseDate: 0,
    latePayment: false,
  },
};

const LiftDashboardContext = React.createContext<[Data, Dispatch] | undefined>(
  undefined
);
type Data = {
  response: {
    status: number;
    statusText: string;
    liftStatus: number;
    liftAmount: number;
    totalBalance: number;
    totalBalanceWithFee: number;
    biWeeklyPayment: number;
    communityContribution: number;
    principalRepayment: number;
    numberOfPayments: number;
    boosterCode: string;
    timeToEnrollBooster: number;
    firstName: string;
    lastName: string;
    boosters: Array<{
      firstName: string;
      lastName: string;
      paymentsByBooster: number;
    }>;
    numberPaymentTillLiftIncrease: number;
    nextPaymentDueDate: number;
    numberPaymentsToGo: number;
    numberPaymentsMade: number;
    liftId: string;
    fractionPayedOff: number;
    maxBoosterCountReached: boolean;
    paymentsByLiftOwner: number;
    bannerMessage: string;
    boosterReleaseDate: number;
    latePayment: boolean;
  };
};

type Action =
  | { type: "setDashboard"; payload: { data: any } }
  | { type: "reset" };

type Dispatch = (action: Action) => void;

const LiftDashboardReducer = (state: Data, action: Action) => {
  switch (action.type) {
    case "setDashboard":
      return { ...state, response: action.payload.data };
    case "reset":
      return { ...initialLiftDashboardState };
    default:
      throw new Error(`unknown action ${action}`);
  }
};

export const LiftDashboardProvider: React.FC = ({ children }) => {
  const [location, dispatch] = useReducer(
    LiftDashboardReducer,
    initialLiftDashboardState
  );
  return (
    <LiftDashboardContext.Provider value={[location, dispatch]}>
      {children}
    </LiftDashboardContext.Provider>
  );
};

export const useLiftDashboardReducer = () => {
  const context = useContext(LiftDashboardContext);
  if (context === undefined)
    throw new Error("lift dashboard context is undefined");
  return context;
};
